import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseGroupPlaybackControls } from './BaseGroup.mjs';

/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */
var GroupPlaybackControls = /*#__PURE__*/function (_BaseGroupPlaybackCon) {
  function GroupPlaybackControls() {
    _classCallCheck(this, GroupPlaybackControls);
    return _callSuper(this, GroupPlaybackControls, arguments);
  }
  _inherits(GroupPlaybackControls, _BaseGroupPlaybackCon);
  return _createClass(GroupPlaybackControls, [{
    key: "then",
    value: function then(onResolve, onReject) {
      return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
  }]);
}(BaseGroupPlaybackControls);
export { GroupPlaybackControls };